export default function Main(data) {
  return JSON.parse(window.atob(data))
}
